import { render, staticRenderFns } from "./Zjhm.vue?vue&type=template&id=242b9435&scoped=true"
import script from "./Zjhm.vue?vue&type=script&lang=js"
export * from "./Zjhm.vue?vue&type=script&lang=js"
import style0 from "./Zjhm.vue?vue&type=style&index=0&id=242b9435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b9435",
  null
  
)

export default component.exports